import React, { useRef } from 'react';
import { Routes, Route, BrowserRouter, useNavigate } from 'react-router-dom';
import Frame from './Frame';
import Home from './home/Home';
import RollerOchPersonal from './personal/RollerOchPersonal';
import DokumentForm from './dokument/DokumentForm';
import LoginOutForm from './standard/LoginOutForm';
import LoginOutModalForm from './user/LoginOutModalForm';
import RegisterForm from './user/RegisterForm';
import AdminDashboard from './user/AdminDashboard';
import SchemaView from './scheman/SchemaView';
import SchemaVoView from './scheman/SchemaVoView';
import Statistik from './statistik/Statistik';
import Excel from './excel/Excel';
import Vo from './vo/Vo';
import NotFound from './NotFound';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalStateProvider } from './contexts/GlobalStateContext';
import {
  useIsAuthorized
} from './contexts/GlobalStateContext';
import { useIdleTimeout } from './hooks/useIdleTimeout';
import { toast } from 'react-toastify';

// ✅ Egen komponent så useNavigate fungerar (måste vara inuti <Router>)
const IdleGuard = () => {
  const { setIsAuthorized } = useIsAuthorized();
  const navigate = useNavigate();
  const toastIdRef = useRef(null);  // ✅ Undvik duplicerade toasts

  const isLoggedIn = !!sessionStorage.getItem('jwt_token');
  const role = sessionStorage.getItem('user_role');
  const isPublicUser = role === 'Standard';

  useIdleTimeout({
    enabled: isLoggedIn && !isPublicUser,
    onWarning: () => {
      // ✅ Visa bara om ingen toast redan visas
      if (!toast.isActive(toastIdRef.current)) {
        toastIdRef.current = toast.warn(
          'Du loggas ut om 2 minuter pga inaktivitet. Rör musen för att fortsätta.',
          {
            toastId: 'idle-warning',
            autoClose: false,      // Stängs inte automatiskt
            closeOnClick: false,
            draggable: false,
          }
        );
      }
    },
    onActive: () => {
      toast.dismiss('idle-warning');  // ✅ Stäng varningen om användaren rör sig
    },
    onLogout: () => {
      toast.dismiss('idle-warning');
      sessionStorage.clear();
      setIsAuthorized(false);
      navigate('/user', { state: { reason: 'idle' } });
    }
  });

  return null;  // Ingen egen UI behövs
};

const App = () => {
  return (
    <GlobalStateProvider>
      <BrowserRouter>
        <IdleGuard /> {/* ✅ Här inne = har tillgång till useNavigate */}
        <Frame>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/personal" element={<RollerOchPersonal />} />
            <Route path="/dokument" element={<DokumentForm />} />
            <Route path="/scheman" element={<SchemaView />} />
            <Route path="/scheman-vo" element={<SchemaVoView />} />
            <Route path="/statistik" element={<Statistik />} />
            <Route path="/excel" element={<Excel />} />
            <Route path="/user" element={<LoginOutModalForm />} />
            <Route path="/newuser" element={<RegisterForm />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/vo" element={<Vo />} />
            <Route path="/standard" element={<LoginOutForm />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Frame>
        <ToastContainer
          position="top-left"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          pauseOnHover={true}
          draggable={true}
          theme="light"
        />
      </BrowserRouter>
    </GlobalStateProvider>
  );
};

export default App;